<template>
    <div>
        <ul class="nav-box" :class="{langStyle:lang == 'zh' || lang == 'ft' || lang == 'ty'}">
            <li class="nav" v-for='(item,index) in navArr' :key='index' :class='{active:item.id==navName}' @click="navTo(item.id)">
                <div><img class="icon" :src="item.cur_img" alt="nav" v-show='item.id!=navName'><img class="icon" :src="item.active_img" alt="nav" v-show='item.id==navName'></div>
                <div class="text">{{item.navName}}</div>
            </li>
            <!-- <router-link class="nav" to="/Trend" tag="li">
                <div><img class="icon" src="../assets/icon_trend_false.png" alt="nav"></div>
                <div class="text">市场走势</div>
            </router-link>
            <router-link class="nav" to="/Investment" tag="li">
                <div><img class="icon" src="../assets/icon_pay_false.png" alt="nav"></div>
                <div class="text">投资理财</div>
            </router-link>

            <router-link class="nav" to="/Customer" tag="li">
                <div><img class="icon" src="../assets/icon_hall_false.png" alt="nav"></div>
                <div class="text">客服</div>
            </router-link>
            <router-link class="nav" to="/User" tag="li">
                <div><img class="icon" src="../assets/icon_my_false.png" alt="nav"></div>
                <div class="text">我的</div>
            </router-link> -->
        </ul>
    </div>
</template>
<script>
    export default {
        name: 'navBar',
        props:['navName'],
        data () {
            return {
                lang: 'en',
                navArr: [
                    {
                        'id':'index',
                        'navName':this.$t('langNew.shouye'),
                        'cur_img': require('@/assets/Mining_machine_gray.png'),
                        'active_img':require('@/assets/Mining_machine_blue.png')
                    },
                    {
                        'id':'loan',
                        'navName':this.$t('langNew2.zb'),
                        'cur_img': require('@/assets/zb_gray.png'),
                        'active_img':require('@/assets/zb_blue.png')
                    },
                    {
                        'id':'contractTransaction',
                        'navName':this.$t('langNew.jghy'),
                        'cur_img': require('@/assets/business.png'),
                        'active_img':require('@/assets/business-light.png')
                    },
                    {
                        'id':'currencyTrading',
                        'navName':this.$t('langNew4.jy'),
                        'cur_img': require('@/assets/share.png'),
                        'active_img':require('@/assets/share-light.png')
                    },
                    // {
                    //     'id':'scList',
                    //     'navName':this.$t('tabObj.sc'),
                    //     'cur_img': require('@/assets/Shopping-Mall.png'),
                    //     'active_img':require('@/assets/Shopping-Mall_light.png')
                    // },
                    // {
                    //     'id':'share',
                    //     'navName':this.$t('yqm.fx'),
                    //     'cur_img': require('@/assets/share.png'),
                    //     'active_img':require('@/assets/share-light.png')
                    // },

                ]
            }
        } ,
        created() {
            this.lang = localStorage.getItem('user_lang');
        },
        methods: {
            navTo(nav){
                this.$router.push('/'+nav);
            }
        },
    }
</script>
<style scoped>
    .nav-box{
        position: fixed;
        left: 0;
        bottom: 0;
        display: flex;
        width: 100%;
        justify-content: space-around;
        height: 1.6rem;
        padding: .06rem 0;
        color: #fff;
        font-size: .28rem;
        background: #040925;
        box-sizing: border-box;
    }
    .nav-box.langStyle{
        padding-top: 0;
        align-items: center;
    }
    .nav-box .nav{
        width: 20%;
        color: #c6c6c6;
        text-align: center;
    }
    .nav-box .nav.active{
        color: #2CAADE;
    }
    .nav-box .nav.active .icon{
        animation: turn .2s linear;
    }
    @keyframes turn {
        0% {
            width: .1rem;
            height: .1rem;
        }
        20% {
            width: .16rem;
            height: .16rem;
        }
        40% {
             width: .2rem;
             height: .2rem;
        }
        60% {
             width: .3rem;
             height: .3rem;
        }
        100% {
            width: .4rem;
            height: .4rem;
        }
    }
    .nav-box .nav .icon{
        /* width: .4rem; */
        height: .58rem;
    }
</style>



// WEBPACK FOOTER //
// src/components/NavBar.vue